import { Spin } from 'antd'

import keys from '@/config/keys'
import { LoadingIndicator, renderLoading } from '@/components/Loading'

export const SPINNING_UI = (
	<div className='flex-center w-full'>
		<Spin size='small' indicator={<LoadingIndicator spin />} />
	</div>
)
export const ELO = {
	// Empty Loadable Options
	fallback: <></>,
}
export const TLO = {
	// Text Loadable Options
	fallback: <span className='text-base font-medium'>{keys.LOADING_COMPONENT_MSG}</span>,
}
export const ILO = {
	// Inline Loadable Options
	fallback: SPINNING_UI,
}
export const BLO = {
	// Inline Loadable Options
	fallback: renderLoading({ tip: keys.LOADING_COMPONENT_MSG, className: 'my-3 w-full' }),
}
